import classNames from 'classnames';

import ButtonLoader from '~/components/Loaders/ButtonLoader';

import styles from './Button.module.css';

export const Button = ({
  buttonText,
  isLoading = false,
  onClick,
  shrinkTextOnMobile = false





}: {buttonText: string;isLoading?: boolean;onClick: () => void;shrinkTextOnMobile?: boolean;}) => {
  const clickHandler = () => {
    if (isLoading) {
      return;
    }

    onClick();
  };

  const buttonStyles = classNames(
    styles.button,
    shrinkTextOnMobile ? styles['--mobileSmall'] : ''
  );

  return (
    <button
      aria-disabled={isLoading}
      aria-label={isLoading ? buttonText : null}
      className={buttonStyles}
      onClick={clickHandler}>

			{isLoading ? <ButtonLoader /> : buttonText}
		</button>);

};